module.exports = __webpack_public_path__ + "media/images/emoticons/mailto-e0131c97a477b675d5036d6bbf991490.gif";